import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-step',
  templateUrl: './step.component.html',
  //styleUrls: ['./step.component.css']
})
export class StepComponent implements OnInit {

  public showServiceUnavailableBanner = false;
  currentYear:number;
  constructor(
  
  ) {
    // This is intentional
  }

  public bannerClosed(): void {
    this.showServiceUnavailableBanner = true;
  }

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
  }

 
}
